import React from "react";
import {cx} from "../../../lib/ClassSet";
import StatusTag from "../../../components/StatusTag";

const PartnerItem = (props) => {
  const {data} = props;
  const active = data.get("active");

  const classes = cx({
    "item": true,
    "partner-list-item": true,
    "u-selected": props.selected,
    "u-inactive": !active,
  });

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-title">{data.get("name")}</td>
      <td className="field">
        {data.get("roles").map((role) =>
          <StatusTag key={role} color={role === "client" ? StatusTag.COLORS.BLUE : StatusTag.COLORS.OUTLINE} noMargin>{role}</StatusTag>
        )}
      </td>
      <td className="field">{data.get("contactName")}</td>
      <td className="field">{data.get("addresses").map((address) => address.get("label")).join(", ")}</td>
      <td className="field f-status">
        <StatusTag color={active ? StatusTag.COLORS.GREEN : StatusTag.COLORS.GREY} noMargin>{active ? "active" : "inactive"}</StatusTag>
      </td>
    </tr>
  )
}

export default PartnerItem;
